import * as React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Footer from 'components/Footer'
import HeaderLarge from 'components/HeaderLarge'
import Information from 'components/Information'
import InputField from 'components/InputField'

const SceneComponent: React.FC = () => {
  const [connectorId, setConnectorId] = React.useState('')
  const navigate = useNavigate()
  const handleLogin = () => {
    console.log('Login clicked with email:', connectorId)
    navigate('/summarySelect')
  }
  return (
    <>
      <HeaderLarge title="新規登録" />
      <Information>
        <p>
          紹介者のAUBEクエストコネクターIDをご入力ください。
          <br />
          ご入力いただけない場合は登録できません。
          <br />
          コネクターIDが不明な場合はご紹介者にご確認ください。
        </p>
      </Information>
      <form>
        <InputField
          name="introduction-connector-id"
          labelTop="紹介者のコネクターID"
          type="text"
          placeholder="紹介者のコネクターIDを入れてください"
          setValue={setConnectorId}
          bold
          className="mt-4"
        />
        <div className="mt-5">
          <Button variant="primary" className="w-100 py-4" onClick={handleLogin}>
            登録する
          </Button>
        </div>
      </form>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
